{
  "en": {
    "task": {
      "actions": {
        "create": "Task",
        "create_and_send": "Create and send",
        "delete": "Delete task",
        "keep_as_draft": "Keep as draft",
        "open_in_project": "Open task in project",
        "remove_from_unit": "Remove task from this unit",
        "save_as_draft": "Save as draft",
        "update": "Edit task"
      },
      "attributes": {
        "assignments_count": "Assignments",
        "category": "Completion method",
        "created_at": "Created",
        "description": "Description",
        "phase": "Phase",
        "title": "Title"
      },
      "categories": {
        "confirmation": "Confirmation",
        "upload": "Document upload"
      },
      "categories_info": {
        "confirmation": "The assignee ticks it off when it is done.",
        "upload": "The assignee has to upload a file to finish it."
      },
      "confirm": {
        "delete_accept": "Delete everywhere",
        "delete_body": "This deletes {count} task across {units}, even if it is already completed. | This deletes all {count} tasks across {units}, including the completed ones.",
        "delete_body_empty": "This deletes the task.",
        "delete_body_project": "This deletes the task and its assignee. | This deletes the task and all {count} of its assignees.",
        "delete_cancel": "Keep task",
        "delete_header": "Delete “{title}”?",
        "delete_silent": "Nobody is notified, and notifications that already went out are not taken back.",
        "publish_body": "We create {tasks} across {units} and send them to their assignees. Each task gets the status Open until it is completed.",
        "publish_body_project": "We create {tasks} in this project and send them to their assignees. Each task gets the status Open until it is completed.",
        "publish_header": "Create and send this task?",
        "publish_info": "Assignees get an email straight away. Save as draft if you are not ready to send yet.",
        "remove_from_unit_accept": "Remove from unit",
        "remove_from_unit_body": "This removes every assignee of this task in this unit. The task and its other units stay untouched.",
        "remove_from_unit_customers": "Customers of this unit no longer see it in their portal.",
        "remove_from_unit_header": "Remove “{title}” from this unit?"
      },
      "deep_link": {
        "show_all": "Show all tasks",
        "single": "You are looking at one task."
      },
      "empty": {
        "filtered_description": "Nothing matches the filters you picked. Clear them to see every task.",
        "filtered_description_project": "Nothing matches the filters you picked. Clear them to see every task in this project.",
        "filtered_title": "No tasks match your filters",
        "none_description": "Create a task and assign it to your team or to the customers of one or more units. It shows up here as soon as you send it.",
        "none_description_sup": "Create a task and assign it to your team or to your customers. It shows up here as soon as you send it.",
        "none_title": "No tasks yet"
      },
      "filters": {
        "phase_none": "No phase",
        "search": "Search task"
      },
      "form": {
        "category_subtitle": "Choose how the assignee marks the task as completed",
        "category_title": "How is it completed?",
        "description_help": "Visible to everyone who gets this task.",
        "description_placeholder": "Add details or instructions",
        "edit_info_assignments": "Manage assignees, units and due dates per assignee in the task list.",
        "edit_info_assignments_project": "Manage assignees and due dates per assignee in the task list.",
        "edit_info_fields": "Edit the title and description here.",
        "edit_info_fields_phase": "Edit the title, description and phase here.",
        "heading_create": "New task",
        "heading_update": "Edit task",
        "phase_help_update": "Every unit that has reached the new phase, or passed it earlier, sees this task straight away. Units that are not there yet see it as soon as they get there.",
        "phase_help_update_project": "If this project has reached the new phase, or passed it earlier, its assignees see this task straight away. Otherwise they see it as soon as the project gets there.",
        "scope_headline": "{count} task will be created and sent | {count} tasks will be created and sent",
        "scope_project": "{assignees} in this project",
        "scope_units": "{units} × {assignees}",
        "title_placeholder": "What needs to happen?",
        "units_selected": "{selected} of {count} unit selected | {selected} of {count} units selected",
        "units_title": "Which units"
      },
      "labels": {
        "assignees_count": "{count} assignee | {count} assignees",
        "created_by": "Created by {name} · {date}",
        "created_on": "Created {date}",
        "required": "This field is required",
        "set_all_assignees": "Set the assignee | Set all {count} assignees",
        "still_to_do": "{count} still to do",
        "tasks_count": "{count} task | {count} tasks",
        "units_count": "{count} unit | {count} units",
        "units_required": "Select at least one unit"
      },
      "toasts": {
        "create": "Task created",
        "delete": "Task deleted",
        "remove_from_unit": "Task removed from this unit",
        "update": "Task updated"
      }
    }
  }
}
